import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { AllRoutesQuery } from '../gql/graphql';

const allRoutes = graphql(/* GraphQL */ `
  query allRoutes {
    routes {
      routeId
      routeName
      countryId
      isTopDestination
    }
  }
`);

const useGetRoutes = () => {
  const { data, isLoading } = useQuery<AllRoutesQuery>({
    queryKey: ['routes'],
    queryFn: async () => graphqlRequest<AllRoutesQuery>(allRoutes), // Public endpoint, no auth needed
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    routes: data,
    routeLoading: isLoading,
  };
};

export default useGetRoutes;
